import React from "react";
import "./logoutConfirmation.css";

const LogoutConfirmationPopup = ({ onCancel, onConfirm }) => {
  return (
    <div className="overlay">
 <div className="logout-confirmation-popup">
      <p className="text-header">Are you sure you want to leave this page?</p>
      <button  className="button" onClick={onCancel}>Cancel</button>
      <button  className="button bg-red" onClick={onConfirm}>Confirm</button>
    </div>
    </div>
   
  );
};

export default LogoutConfirmationPopup;
